export default "__VITE_ASSET__BE9cXPqg__"